import Swal from "sweetalert2";
import dayjs from "dayjs";

export default {
  namespaced: true,
  state: {
    markAsPaidLoading: false,
    upcomingAppointments: [],
    upcomingAppointmentsLoading: false,
  },
  mutations: {
    SET_MARK_AS_PAID_LOADING(state, payload) {
      state.markAsPaidLoading = payload;
    },
    SET_UPCOMING_APPOINTMENTS(state, data) {
      state.upcomingAppointments = data;
    },
    SET_UPCOMING_LOADING(state, val) {
      state.upcomingAppointmentsLoading = val;
    },
  },
  actions: {
    getUpcoming: function (
      { commit },
      { userId, isProvider, isAdmin, isManagingAdmin }
    ) {
      const vm = this;
      commit("SET_UPCOMING_LOADING", true);
      const start = dayjs().startOf("day").toISOString();
      const end = dayjs().endOf("day").toISOString();

      const formatTime = (t) =>
        dayjs(t)
          .add(-1 * dayjs(t).utcOffset(), "minute")
          .format("hh:mm A");

      const apptCall = vm.$http.get(
        `users/${userId}/appointments?start=${start}&end=${end}&size=9999`
      );

      const gsParam =
        isProvider || isAdmin || isManagingAdmin
          ? `provider_user_id=${userId}`
          : `client_id=${userId}`;
      const gsCall = vm.$http.get(
        `group-sessions-calendar?start=${start}&end=${end}&${gsParam}`
      );

      return new Promise((resolve) => {
        Promise.allSettled([apptCall, gsCall]).then(
          ([apptResult, gsResult]) => {
            if (gsResult.status === "rejected") {
              console.warn("Group sessions fetch failed:", gsResult.reason);
            }

            const appointments =
              apptResult.status === "fulfilled"
                ? (apptResult.value.data?.data || []).map((appt) => ({
                    id: `appt_${appt.id}`,
                    rawStart: appt.start_time,
                    time: formatTime(appt.start_time),
                    patientName: appt.patient_name || "—",
                    type: appt.type || "—",
                    service: appt.main_service_name || "—",
                    isGroup: false,
                  }))
                : [];

            const groupSessions =
              gsResult.status === "fulfilled"
                ? (gsResult.value.data?.data || []).map((gs) => ({
                    id: `gs_${gs.session_id}`,
                    rawStart: gs.start,
                    time: formatTime(gs.start),
                    patientName: gs.program_name || gs.title || "—",
                    type: gs.session_type || "—",
                    service: `${gs.participant_count ?? 0} participants`,
                    isGroup: true,
                  }))
                : [];

            const merged = [...appointments, ...groupSessions].sort(
              (a, b) => new Date(a.rawStart) - new Date(b.rawStart)
            );

            commit("SET_UPCOMING_APPOINTMENTS", merged);
            commit("SET_UPCOMING_LOADING", false);
            resolve(merged);
          }
        );
      });
    },
    markAsPaid: function ({ commit }, appointmentId) {
      const vm = this;
      commit("SET_MARK_AS_PAID_LOADING", appointmentId);
      return new Promise((resolve) => {
        return vm.$http.post(`appointments/${appointmentId}/mark-as-paid`).then(
          () => {
            commit("SET_MARK_AS_PAID_LOADING", false);
            resolve(true);
          },
          (err) => {
            commit("SET_MARK_AS_PAID_LOADING", false);
            if (!err.accessDenied) {
              Swal.fire({
                title: "Error",
                text:
                  err?.data?.error?.message ||
                  err?.data?.message ||
                  "Something went wrong...",
                icon: "error",
              });
            }
            resolve(false);
          }
        );
      });
    },
  },
};
